// src/react/SlashPlugin.tsx
import { toPlatePlugin } from "@udecode/plate-common/react";

// src/lib/BaseSlashPlugin.ts
import {
  withTriggerCombobox
} from "@udecode/plate-combobox";
import {
  createSlatePlugin,
  createTSlatePlugin
} from "@udecode/plate-common";
var BaseSlashInputPlugin = createSlatePlugin({
  key: "slash_input",
  node: { isElement: true, isInline: true, isVoid: true }
});
var BaseSlashPlugin = createTSlatePlugin({
  key: "slash_command",
  extendEditor: withTriggerCombobox,
  options: {
    createComboboxInput: () => ({
      children: [{ text: "" }],
      type: BaseSlashInputPlugin.key
    }),
    trigger: "/",
    triggerPreviousCharPattern: /^\s?$/
  },
  plugins: [BaseSlashInputPlugin]
});

// src/react/SlashPlugin.tsx
var SlashInputPlugin = toPlatePlugin(BaseSlashInputPlugin);
var SlashPlugin = toPlatePlugin(BaseSlashPlugin);
export {
  SlashInputPlugin,
  SlashPlugin
};
//# sourceMappingURL=index.mjs.map